/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Candidate } from './Candidate';
import {
    CandidateFromJSON,
    CandidateFromJSONTyped,
    CandidateToJSON,
    CandidateToJSONTyped,
} from './Candidate';

/**
 * 
 * @export
 * @interface BoxSplitOrderInfoVo
 */
export interface BoxSplitOrderInfoVo {
    /**
     * 当前状态和有效费用是否允许按箱拆分
     * @type {boolean}
     * @memberof BoxSplitOrderInfoVo
     */
    allowed?: boolean;
    /**
     * 不允许操作的原因，按请求语言返回
     * @type {string}
     * @memberof BoxSplitOrderInfoVo
     */
    disabledReason?: string;
    /**
     * 保存箱与箱内商品行快照版本
     * @type {string}
     * @memberof BoxSplitOrderInfoVo
     */
    packingVersion?: string;
    /**
     * 订单状态、包装和商品结构数量版本
     * @type {string}
     * @memberof BoxSplitOrderInfoVo
     */
    orderVersion?: string;
    /**
     * 已保存包装候选，含箱、商品行和单箱禁用原因
     * @type {Array<Candidate>}
     * @memberof BoxSplitOrderInfoVo
     */
    boxes?: Array<Candidate>;
    /**
     * 原订单成功整箱拆出的箱唛，不允许原订单重新装箱时复用
     * @type {Array<string>}
     * @memberof BoxSplitOrderInfoVo
     */
    unavailableBoxMarkNos?: Array<string>;
}

/**
 * Check if a given object implements the BoxSplitOrderInfoVo interface.
 */
export function instanceOfBoxSplitOrderInfoVo(value: object): value is BoxSplitOrderInfoVo {
    return true;
}

export function BoxSplitOrderInfoVoFromJSON(json: any): BoxSplitOrderInfoVo {
    return BoxSplitOrderInfoVoFromJSONTyped(json, false);
}

export function BoxSplitOrderInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BoxSplitOrderInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'allowed': json['allowed'] == null ? undefined : json['allowed'],
        'disabledReason': json['disabledReason'] == null ? undefined : json['disabledReason'],
        'packingVersion': json['packingVersion'] == null ? undefined : json['packingVersion'],
        'orderVersion': json['orderVersion'] == null ? undefined : json['orderVersion'],
        'boxes': json['boxes'] == null ? undefined : ((json['boxes'] as Array<any>).map(CandidateFromJSON)),
        'unavailableBoxMarkNos': json['unavailableBoxMarkNos'] == null ? undefined : json['unavailableBoxMarkNos'],
    };
}

export function BoxSplitOrderInfoVoToJSON(json: any): BoxSplitOrderInfoVo {
    return BoxSplitOrderInfoVoToJSONTyped(json, false);
}

export function BoxSplitOrderInfoVoToJSONTyped(value?: BoxSplitOrderInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allowed': value['allowed'],
        'disabledReason': value['disabledReason'],
        'packingVersion': value['packingVersion'],
        'orderVersion': value['orderVersion'],
        'boxes': value['boxes'] == null ? undefined : ((value['boxes'] as Array<any>).map(CandidateToJSON)),
        'unavailableBoxMarkNos': value['unavailableBoxMarkNos'],
    };
}

